import axios from 'axios';
// import { customConfigs } from '../config';
export default {
    state: {
        getUrl(){
            return axios.create({
              baseURL: process.env.VUE_APP_CIPHER_URL,
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-DreamFactory-Api-Key': process.env.VUE_APP_CIPHER_TOKEN
              }
            });
        }
    },
    searchUser(keyword){
        return this.state.getUrl().get('/mst_user', {
            params: {
                "fields": "code,boss_code,username,firstname,lastname,displayname,email",
                "filter": "(firstname like %"+keyword+"%) or (email like %"+keyword+"%)",
                "timestamp": new Date().getTime()
            }

        })
        .then(function (response) {
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            return Promise.reject(error.response.error);
        });
    },
    getUserInfo(code){
        return this.state.getUrl().get('/mst_user', {
            params: {
                // "fields": "code,username,firstname,lastname,displayname,email",
                "filter": "(code='"+code+"')",
                "timestamp": new Date().getTime()
            }
        })
        .then(function (response) {
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            return Promise.reject(error.response.error);
        });
    },
    getUnitMaster() {
        return this.state.getUrl().get('/mst_itemunit')
            .then(function (response) {
                return Promise.resolve(response.data);
            })
            .catch(function (error) {
                return Promise.reject(error.response.error);
            });
    },
    getGroups() {
        return this.state.getUrl().get('/mst_product_hc', {
                params: {
                    "filter": "(category = 'product_group')",
                    "timestamp": new Date().getTime()
                }
            })
            .then(function (response) {
                return Promise.resolve(response.data.resource);
            })
            .catch(function (error) {
                return Promise.reject(error.response.error);
            });
    },
    getSubgroups(parentCode) {

        return this.state.getUrl().get('/mst_product_hc', {
                params: {
                    "filter": "(parentCode = '"+parentCode+"')",
                    "timestamp": new Date().getTime()
                }
            })
            .then(function (response) {
                return Promise.resolve(response.data.resource);
            })
            .catch(function (error) {
                return Promise.reject(error.response.error);
            });
    },
    getProductsGroup(productGroup) {

        let products = productGroup.map(x => "'" + x + "'").toString();

        return this.state.getUrl().get('/mst_product', {
            params: {
                "fields": "code,title,title_th,selling_um",
                "filter": "code in ("+products+")",
                "timestamp": new Date().getTime()
            }

        })
        .then(function (response) {
            return Promise.resolve(response.data.resource);
        })
        .catch(function (error) {
            return Promise.reject(error.response.error);
        });
    },
    searchProducts(productGroup) {

        let products = productGroup.map(x => "'" + x + "'").toString();

        return this.state.getUrl().get('/mst_product', {
            params: {
                "fields": "code,title,title_th,selling_um",
                "filter": "code in ("+products+")",
                "timestamp": new Date().getTime()
            }

        })
        .then(function (response) {
            return Promise.resolve(response.data.resource);
        })
        .catch(function (error) {
            return Promise.reject(error.response.error);
        });
    },
    getProductBrowse(params) {
        var where = ""
        // var filters = ""
        // var fields = ["code", "title_th", "selling_um", 'productcg_code', 'cost', 'price']
        // var order = "title_th asc"
        if (params['cggroupsMode']) {
            where = "(productcg_code = '"+params['cggroupsMode']+"')";
            // where = {
            //     "and": [{
            //         "productcg_code": params['cggroupsMode']
            //     }]
            // }
            // filters = {
            //     "and": [{
            //         "productcg_code": params['cggroupsMode']
            //     }, {
            //         "or": [{
            //             "code": {
            //                 "like": params['keyword']
            //             }
            //         }, {
            //             "title_th": {
            //                 "like": params['keyword']
            //             }
            //         }]
            //     }]
            // }
        } else if (params['subgroupsMode']) {
            where = "(productsubgroup_code = '"+params['subgroupsMode']+"')";
            // where = {
            //     "and": [{
            //         "productsubgroup_code": params['subgroupsMode']
            //     }]
            // }
            // filters = {
            //     "and": [{
            //         "productsubgroup_code": params['subgroupsMode']
            //     }, {
            //         "or": [{
            //             "code": {
            //                 "like": params['keyword']
            //             }
            //         }, {
            //             "title_th": {
            //                 "like": params['keyword']
            //             }
            //         }]
            //     }]
            // }
        } else if (params['groupsMode']) {
            where = "(productgroup_code = '"+params['groupsMode']+"')";
            // where = {
            //     "and": [{
            //         "productgroup_code": params['groupsMode']
            //     }]
            // }
            // filters = {
            //     "and": [{
            //         "productgroup_code": params['groupsMode']
            //     }, {
            //         "or": [{
            //             "code": {
            //                 "like": params['keyword']
            //             }
            //         }, {
            //             "title_th": {
            //                 "like": params['keyword']
            //             }
            //         }]
            //     }]
            // }
        }

        if (params['keyword']) {
            if(where)
            {
                where = "(code like %"+params['keyword']+"%) or (title like %"+params['keyword']+"%) or (title_th like %"+params['keyword']+"%) and "+ where
            }else{
                where = "(code like %"+params['keyword']+"%) or (title like %"+params['keyword']+"%) or (title_th like %"+params['keyword']+"%)";
            }

            // where = (where) ? filters : {
            //     "or": [{
            //         "code": {
            //             "like": params['keyword']
            //         }
            //     }, {
            //         "title_th": {
            //             "like": params['keyword']
            //         }
            //     }]
            // }
        }

        if(where != '')
            where += " and (status = '1') and (productlifecycle_code in ['41','42','43','44','45','51','52','53','54'])";

        return this.state.getUrl().get('/mst_product', {
                params: {
                    "fields": "code,title_th,selling_um,productcg_code,cost,price",
                    "filter": where,
                    "limit": 100,
                    "timestamp": new Date().getTime()
                }
            })
            .then(function (response) {
                return Promise.resolve(response.data.resource);
            })
            .catch(function (error) {
                return Promise.reject(error.response.error);
            });
    },
    getCustomerArea(){
        // let where = '';

        return this.state.getUrl().get('/mst_customer_bparea', {
            params: {
                "fields": "code,title",
                // "fields": "code,title_th,selling_um,productcg_code,cost,price",
                // "filter": where,
                // "limit": 100,
                "timestamp": new Date().getTime()
            }
        })
        .then(function (response) {
            return Promise.resolve(response.data.resource);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
    },
    getCustomerType(){
        // let where = '';

        return this.state.getUrl().get('/mst_customer_bptype', {
            params: {
                "fields": "code,title",
                // "filter": where,
                // "limit": 100,
                "timestamp": new Date().getTime()
            }
        })
        .then(function (response) {
            return Promise.resolve(response.data.resource);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
    },
    getCustomerCode(){
        // let where = '';

        return this.state.getUrl().get('/mst_customer', {
            params: {
                "fields": "code",
                // "filter": where,
                // "limit": 100,
                "timestamp": new Date().getTime()
            }
        })
        .then(function (response) {
            return Promise.resolve(response.data.resource);
        })
        .catch(function (error) {
            return Promise.reject(error.response.error);
        });
    },
    getCustomerByCode(code){

        return this.state.getUrl().get('/mst_customer', {
            params: {
                "fields": "code,title,title_th,bparea_code,bptype_code",
                "filter": "(code='"+code+"')",
                // "limit": 100,
                "timestamp": new Date().getTime()
            }
        })
        .then(function (response) {
            return Promise.resolve(response.data.resource[0]);
        })
        .catch(function (error) {
            return Promise.reject(error.response.error);
        });
    },
    searchCustomer(params){

        console.log(params);
        //let condition = "";
        let keyword = params.keyword;

        let filter = "";


        if(params.customerArea != "")
            filter = filter + "(bparea_code='"+params.customerArea+"')";

        if(params.customerType != "")
            filter = filter + " and (bptype_code='"+params.customerType+"')";

        if((params.customerArea != "" || params.customerType != "") && params.keyword != '')
            filter = filter + " and ";

        if(params.keyword != '')
            filter = filter + "(code like %"+keyword+"%) or (title_th like %"+keyword+"%) or (title like %"+keyword+"%)";

        // console.log(params)

        // if(params.customerCode)
        //     filter = "(code = "+params.customerCode+")";

        // filter += "and (status = 'Active')"



        return this.state.getUrl().get('/mst_customer', {
            params: {
                "fields": "code,title,title_th,bparea_code,bptype_code",
                "filter": filter,
                "limit": 5000,
                "timestamp": new Date().getTime()
            }
        })
        .then(function (response) {
            return Promise.resolve(response.data.resource);
        })
        .catch(function (error) {
            return Promise.reject(error.response.error);
        });
    },
    getBossCode(emp_code){
        return this.state.getUrl().get('/mst_user', {
            params: {
                "fields": "boss_code",
                "filter": "(code='"+emp_code+"')",
                "timestamp": new Date().getTime()
            }
        })
        .then(function (response) {
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            return Promise.reject(error.response.error);
        });
    },
}
